// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"6c66c9b3","149":"1c57c22c","179":"e4a21c5a","213":"d1ba6022","393":"48a448d5","446":"e1022bfa","447":"76a48fdd","453":"4c1f892b","455":"8d940864","828":"3960b08a","967":"b8447ab5"}[chunkId] + ".chunk.js";
};